import { render, staticRenderFns } from "./TipText.vue?vue&type=template&id=11abfa34&scoped=true&"
import script from "./TipText.vue?vue&type=script&lang=js&"
export * from "./TipText.vue?vue&type=script&lang=js&"
import style0 from "./TipText.vue?vue&type=style&index=0&id=11abfa34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11abfa34",
  null
  
)

export default component.exports